import { Injectable } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";

@Injectable({
  providedIn: "root",
})
export class DateFormatService {
  constructor(private translateService: TranslateService) {}

  formatDate(
    date: Date | string,
    options?: Intl.DateTimeFormatOptions,
  ): string {
    const currentLang = this.translateService.currentLang || "en";
    const locale = this.getLocaleFromLang(currentLang);

    const defaultOptions: Intl.DateTimeFormatOptions = {
      year: "numeric",
      month: "long",
      day: "numeric",
    };

    const dateObj = typeof date === "string" ? new Date(date) : date;

    return dateObj.toLocaleDateString(locale, {
      ...defaultOptions,
      ...options,
    });
  }

  private getLocaleFromLang(lang: string): string {
    switch (lang) {
      case "pl":
        return "pl-PL";
      case "es":
        return "es-ES";
      case "en":
      default:
        return "en-US";
    }
  }

  formatNextMonthDate(): string {
    const nextMonth = new Date();
    nextMonth.setMonth(nextMonth.getMonth() + 1);
    nextMonth.setDate(1);
    return this.formatDate(nextMonth);
  }
}
